<template>
  <div id="app">
    <div id="container">
      <router-view v-if="isReload" />
    </div>
  </div>
</template>

<script>
window._CONFIG = {}
//window._CONFIG['domianURL'] = 'http://localhost:9991/jeecg-boot';
window._CONFIG['domianURL'] = 'http://oa.zschanghong.net:9991/jeecg-boot';

  export default {
    provide() {
      return {
        reload: this.reload,
      }
    },
    data() {
      return {
        isReload: true
       }
    },
    created() {   },
    methods: { 
      reload() {
        this.isReload = false
        this.$nextTick(() => {
          this.isReload = true
        })
      }
    },
  }
</script>

<style lang="less">
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Arial", Avenir, Helvetica,  "Microsoft YaHei", "黑体",  "FangSong", "STSong", "STKaiti", "sans-serif" ;
}
#container {
  max-width: 740px;
  background-color: #fff;
  margin: 0 auto;
  min-height: 100vh;
}
html,body,p {
  margin: 0;
  padding: 0;
  list-style: none;
}
body {
  background: #eee;
}
</style>
